import styled from 'styled-components';
import { Checkbox } from 'cdk-radial';

const StyledCustomHeaderCheckbox = styled(Checkbox)`
  span {
    margin-left: 3px;
  }
`;

export default StyledCustomHeaderCheckbox;
